import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import useCountUp from '../../../shared/useCountUp'

import styles from './style.module.scss'

/**
 * Eine Zahl der öffentlichen Startseite: Unternehmen, Schüler:innen, Schulen.
 *
 * Die Zahl zählt beim Erscheinen hoch (siehe `shared/useCountUp`) und trägt
 * einen Tausenderpunkt — „5587" liest sich als Ziffernfolge, „5.587" als
 * Menge.
 */
export default function SingleData(props) {
	const { t, i18n } = useTranslation()
	/*
	 * `useCountUp` gibt ein **Objekt** zurück (siehe `shared/useCountUp.test.js`).
	 * Als die Form am 26.08.2026 kurz auf ein Array wechselte, rief diese Zeile
	 * `undefined.toLocaleString()` — und die öffentliche Startseite blieb weiß.
	 */
	const { elementRef, wert } = useCountUp(props.data)

	/*
	 * Die Trennung folgt der Sprache: im Deutschen der Punkt, im Englischen das
	 * Komma.
	 *
	 * **Nicht `de-AT`** — dessen Zeichensatz trennt Tausender mit einem schmalen
	 * Leerzeichen („5 587") statt mit dem Punkt, den man hier erwartet. Für die
	 * reine Zifferngruppierung ist `de-DE` das Richtige.
	 */
	const zahl = wert.toLocaleString(i18n.language === 'en' ? 'en-GB' : 'de-DE')

	return (
		<div className={styles.root} ref={elementRef}>
			<h1 className={styles.header}>{t(props.header.toLowerCase())}</h1>
			<h2 className={styles.existNumber}>{zahl}</h2>
		</div>
	)
}

SingleData.propTypes = {
	header: PropTypes.string.isRequired,
	data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}
